import SectionHeader from '../ui/SectionHeader';
import BookCarousel from './BookCarousel';
import BookSpotlightCard from './BookSpotlightCard';
import { BookCardSkeleton } from '../ui/Skeleton';

function CarouselSkeleton() {
  return (
    <div className="flex gap-6 overflow-hidden">
      {Array.from({ length: 5 }).map((_, i) => (
        <div key={i} className="w-[42%] shrink-0 sm:w-[30%] lg:w-[19%]">
          <BookCardSkeleton />
        </div>
      ))}
    </div>
  );
}

// A book list section adapts its layout to how many books actually landed
// in it, rather than always forcing a carousel meant for browsing a longer
// list: a single book takes the full-width spotlight treatment (size="lg")
// instead of sitting as one small carousel card with empty scroll space
// beside it, two books get the side-by-side spotlight treatment used by the
// hand-curated Featured Books banner, and three or more fall back to the
// normal scrollable carousel. An empty section — heading included — simply
// doesn't render; there's no editorial reason to show a header over blank
// space.
export default function BookSection({ title, subtitle, to, linkLabel, books, loading, badgeOverride, eyebrow }) {
  if (!loading && books.length === 0) return null;

  return (
    <section className="container-app py-10">
      <SectionHeader title={title} subtitle={subtitle} to={to} linkLabel={linkLabel} />

      {loading ? (
        <CarouselSkeleton />
      ) : books.length === 1 ? (
        <div className="overflow-hidden rounded-xl3 border border-slate-100 dark:border-white/10 bg-white dark:bg-surface-darkCard">
          <BookSpotlightCard book={books[0]} size="lg" eyebrow={eyebrow} />
        </div>
      ) : books.length === 2 ? (
        <div className="grid gap-4 overflow-hidden rounded-xl3 border border-slate-100 dark:border-white/10 bg-white dark:bg-surface-darkCard sm:grid-cols-2 sm:gap-0 sm:divide-x sm:divide-slate-100 dark:sm:divide-white/10">
          {books.map((book) => (
            <BookSpotlightCard key={book.id} book={book} eyebrow={eyebrow} />
          ))}
        </div>
      ) : (
        <div className="overflow-x-auto overflow-y-hidden hide-scrollbar">
          <BookCarousel books={books} badgeOverride={badgeOverride} />
        </div>
      )}
    </section>
  );
}
